import "./styles.scss";
// import React, { useState } from "react";
import { useSelector } from "react-redux";

import ButtonBet from "./components/ButtonBet";
import ListCartTicket from "../../components/ListCartTicket";
// import ListCartTicketLine from "../../components/ListCartTicketLine";
import ListCartTicketMobile from "../../components/ListCartTicketMobile";
import ClosingContest from "../../components/ClosingContest";
import {
  getContestsCarousel,
  // getContestsCarouselLive,
} from "../../redux/contests/selectors";
import useDeviceDetect from "../../hook/useDeviceDetect";

import { selectCoinPrice } from "../../redux/selectors";
import MenuNavigate from "../../components/MenuNavigate";
import HowToPlay from "../../components/HowToPlay";
import { useTheme } from "../../hook/useThemes";
import TitleDesktop from "./components/TitleDesktop";
import TitleMobile from "./components/TitleMobile";
import useScreen, { SCREEN_LIST } from "../../hook/useScreen";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import ButtonBetMin from "./components/ButtonBetMin";

function HomePage() {
  const dataList = useSelector(getContestsCarousel);
  const livePrice = useSelector(selectCoinPrice("BTC"));
  const { isTablet } = useDeviceDetect();
  // const [typeCard, setTypeCard] = useState<string>("box");
  const [indexCard, setIndexCard] = useState<number>(0);

  const { lang, settingCard, operatorId } = useTheme();
  const { tracker = "vertical" } = settingCard;
  const typeCard = "box";

  const heightScreen = useScreen();
  const isMinHeight = heightScreen < SCREEN_LIST.screenHeight3;

  return (
    <div className="wrapper-home-page">
      {/* <div className="container wrapper-content-btc">
        {!isMobile && <p className="description-title">
          <span>Bitcoin 1-minute game</span> Every minute, the price is locked
          and a new round starts.
        </p>}
      </div> */}

      <ClosingContest>
        <div className="container wrapper-title-content-bet">
          {!isTablet && (
            <TitleDesktop
              lang={lang}
              operatorId={operatorId}
              livePrice={livePrice}
              indexCard={indexCard}
            />
          )}
          {isTablet && (
            <TitleMobile
              lang={lang}
              operatorId={operatorId}
              livePrice={livePrice}
              indexCard={indexCard}
            />
          )}
        </div>
      </ClosingContest>

      {!!dataList?.length && (
        <>
          {typeCard === "box" && (
            <>
              {!isTablet && (
                <div
                  className={`wrapper-ListCartTicket wrapper-ListCartTicket-${tracker}`}
                >
                  <ListCartTicket
                    dataList={dataList}
                    onChangeIndex={setIndexCard}
                  />
                </div>
              )}
              {isTablet && (
                <div className={`wrapper-CartTicketMobile`}>
                  <ListCartTicketMobile
                    dataList={dataList}
                    onChangeIndex={setIndexCard}
                  />
                </div>
              )}
            </>
          )}

          {/* {typeCard === "line" && (
            <div className="wrapper-ListCartTicketLine">
              <div className="container">
                <ListCartTicketLine
                  dataList={dataList}
                  onConfirmSelectCard={() => {}}
                />
              </div>
            </div>
          )} */}
          <div className={`bottom-bar ${isMinHeight && "bottom-bar-min"}`}>
            {isTablet && <MenuNavigate />}
            {heightScreen < SCREEN_LIST.screenHeight2 ? (
              <ButtonBetMin />
            ) : (
              <ButtonBet />
            )}
            {isTablet && <HowToPlay />}
          </div>
        </>
      )}
      {!dataList?.length && (
        <div className="wrap-loading">
          <p>{lang?.loading || "Loading result"}</p>
          <CircularProgress
            size={24}
            className="circular-progress"
            style={{
              color: "#B3BECE",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default HomePage;
